import { superAdminService, PlanItem } from '../services/superAdminService';
import { useCrudResource } from './useCrudResource';

type CreatePlanPayload = Parameters<typeof superAdminService.createPlan>[0];
type UpdatePlanPayload = Parameters<typeof superAdminService.updatePlan>[1];

export const usePlanes = () => {
  const crud = useCrudResource<PlanItem, CreatePlanPayload, UpdatePlanPayload>({
    queryKey: ['superPlanes'],
    fetchList: superAdminService.getPlanes,
    create: (payload) => superAdminService.createPlan(payload),
    update: (id, payload) => superAdminService.updatePlan(id, payload),
    remove: (id) => superAdminService.deletePlan(id),
  });

  const updatePlan = (
    vars: { id: number; payload: UpdatePlanPayload },
    options?: Parameters<typeof crud.update>[1]
  ) => crud.update({ id: vars.id, data: vars.payload }, options);

  return {
    planes: crud.items,
    isLoading: crud.isLoading,
    isFetching: crud.isFetching,
    error: crud.error,
    refetch: crud.refetch,
    createPlan: crud.create,
    updatePlan,
    deletePlan: crud.remove,
    isCreating: crud.isCreating,
    isUpdating: crud.isUpdating,
    isDeleting: crud.isRemoving,
  };
};
